import CaseOverviewDetails from './CaseOverviewDetails';

export default CaseOverviewDetails;
